/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQ
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQ = FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQ {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQ {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWizQ | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsWizQ);
    }

    return {};
}

